// src/utils/imageOptimization.js
// ─────────────────────────────────────────────────────────────────────────────
// Cloudinary URL transformer for the React web frontend.
//
// Injects Cloudinary transformation parameters into a URL:
//   - Resizes to specified square pixel dimension (default 50x50)
//   - Auto-format (f_auto) and auto-quality (q_auto)
//   - Crop-to-fill (c_fill)
//
// Prevents double-injection if the URL already contains the transformation string.
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Injects Cloudinary transformation parameters into a secure URL.
 * Defaults to 50x50 pixels, auto-format, auto-quality, and crop-to-fill.
 *
 * @param {string|null|undefined} url   - The original Cloudinary image URL.
 * @param {number}                size  - The square pixel size to request (default: 50).
 * @returns {string|null}               - The optimized URL, or the original if not Cloudinary.
 */
export const getOptimizedAvatar = (url, size = 50) => {
  // Return the original URL if it's missing or isn't a Cloudinary link
  if (!url || !url.includes('cloudinary.com')) return url;

  // Prevent double-injection if the URL specified already has our size param
  if (url.includes(`/w_${size}`)) return url;

  // Cloudinary URLs always contain '/upload/'. We inject our params right after it.
  if (!url.includes('/upload/')) return url;

  return url.replace('/upload/', `/upload/w_${size},h_${size},c_fill,f_auto,q_auto/`);
};
